export default __webpack_public_path__ + "images/94e39d7b4e778067ce8d1ba1ef2ef0e4-howitworks.png";